import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StoreSearchEntry } from '../models/store-search-entry';
import { Merchandise } from '../models/merchandise';
import { environment } from '../../environments/environment';
import * as requests from '../requests/index';
import { PlanogramService } from './planogram.service';
import { ProductReference } from "../models/layout/product-reference";
import { SignalRService } from './signalr.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private apiUrl = environment.apiUrl;

  private downloadCompletedSubject: Subject<boolean> = new Subject<boolean>();
  public downloadCompleted$: Observable<boolean> = this.downloadCompletedSubject.asObservable();
  private loadingSubject: Subject<boolean> = new Subject<boolean>();
  public loading$: Observable<boolean> = this.loadingSubject.asObservable();

  constructor(
    private http: HttpClient,
    private signalRService: SignalRService) {
    this.loadingSubject.next(false);
  }
  
  downloadFile(url : string, payload : any): Observable<HttpResponse<Blob>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post(url, payload, {
      headers: headers,
      observe: 'response',
      responseType: 'blob'
    }).pipe(
      catchError((error) => {
        console.error('HTTP Request failed, returning observable of error');
        return throwError(error);
      })
    );
  }

  isLoading(): boolean {
    return this.signalRService.isLoading();
  }

  isValidPlanogram(planogramId: string): Observable<boolean> {
    const url = `${this.apiUrl}/folders/is-valid-planogram`;
    return this.http.post<any>(url, new requests.ValidPlanogramRequest(planogramId));
  }

  searchStores(searchTerm: string, dataSourceId: string | null = null): Observable<StoreSearchEntry[]> {
    const url = `${this.apiUrl}/search/stores`;
    return this.http.post<any>(url, new requests.StoresSearchRequest(searchTerm, dataSourceId));
  }

  getMerchandiseCategories(searchTerm: string, storeGuid?: string): Observable<Merchandise[]> {
  const url = `${this.apiUrl}/search/merchandise`;
  return this.http.post<any>(url, new requests.SearchMerchandiseRequest(searchTerm, storeGuid));
}
}
